import { useState } from 'react';
import { TradingText } from '@trading-ui/core';
import { useTranslation } from 'react-i18next';

import { useActiveCompanies } from '@/views/settings_view/hooks/api/useActiveCompanies';
import { usePendingActions } from '@/views/settings_view/hooks/api/usePendingActions';

import { ActiveCompaniesTable, PendingActionsTable } from '@/views/settings_view/components/tables';
import { getCompanyColumns } from '@/views/settings_view/components/tables/active-companies-table/constants/columns';
import { getActionsColumns } from '@/views/settings_view/components/tables/pending-actions-table/constants/columns';

import useSettingsStore from '@/views/settings_view/store/useSettingsStore';

import * as styles from './MoeveActionsTab.css';
import { MoeveUserModal } from '../../modals';

export default function MoeveActionsTab() {
  const [moeveUserActionId, setMoeveUserActionId] = useState<number | null>(null);

  const { pendingActions, isLoading, isRefetching, handleChangeActionStatus } = usePendingActions();

  const { t } = useTranslation();

  const {
    isLoading: isActiveCompaniesLoading,
    isRefetching: isActiveCompaniesRefetching,
    handleDeleteCompany,
  } = useActiveCompanies();

  const { activeCompaniesFiltered } = useSettingsStore();

  return (
    <>
      <div className={styles.root}>
        <div className={styles.tableContainer}>
          <TradingText text={t('settings.moeveActionsTab.pendingActions.title')} variant="h6" />
          <PendingActionsTable
            columns={getActionsColumns({ handleChangeActionStatus, setMoeveUserActionId })}
            data={pendingActions}
            isLoading={isLoading}
            isRefetching={isRefetching}
          />
        </div>
        <div className={styles.tableContainer}>
          <TradingText text={t('settings.moeveActionsTab.activeCompanies.title')} variant="h6" />
          <ActiveCompaniesTable
            columns={getCompanyColumns({ handleDeleteCompany })}
            data={activeCompaniesFiltered}
            isLoading={isActiveCompaniesLoading}
            isRefetching={isActiveCompaniesRefetching}
          />
        </div>
      </div>
      {moeveUserActionId && (
        <MoeveUserModal
          actionId={moeveUserActionId}
          setIsOpen={setMoeveUserActionId}
          handleChangeActionStatus={handleChangeActionStatus}
        />
      )}
    </>
  );
}
